/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ExamineeExamViewDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
/**
 * ExamineeExamApi - axios parameter creator
 * @export
 */
export const ExamineeExamApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a minimal, read-only view of the individual exam for the examinee. Only the authenticated user matching the exam participant\'s email may access this endpoint. Shared reports are visible only when the exam is in STARTED status. 
         * @summary Get examinee read-only view of their individual exam
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExamineeExamView: async (certificationId: number, stageId: number, examId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getExamineeExamView', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getExamineeExamView', 'stageId', stageId)
            // verify required parameter 'examId' is not null or undefined
            assertParamExists('getExamineeExamView', 'examId', examId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/exams/{examId}/examinee-view`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examId"}}`, encodeURIComponent(String(examId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExamineeExamApi - functional programming interface
 * @export
 */
export const ExamineeExamApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExamineeExamApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a minimal, read-only view of the individual exam for the examinee. Only the authenticated user matching the exam participant\'s email may access this endpoint. Shared reports are visible only when the exam is in STARTED status. 
         * @summary Get examinee read-only view of their individual exam
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExamineeExamView(certificationId: number, stageId: number, examId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExamineeExamViewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExamineeExamView(certificationId, stageId, examId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamineeExamApi.getExamineeExamView']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExamineeExamApi - factory interface
 * @export
 */
export const ExamineeExamApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExamineeExamApiFp(configuration)
    return {
        /**
         * Returns a minimal, read-only view of the individual exam for the examinee. Only the authenticated user matching the exam participant\'s email may access this endpoint. Shared reports are visible only when the exam is in STARTED status. 
         * @summary Get examinee read-only view of their individual exam
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExamineeExamView(certificationId: number, stageId: number, examId: string, options?: RawAxiosRequestConfig): AxiosPromise<ExamineeExamViewDto> {
            return localVarFp.getExamineeExamView(certificationId, stageId, examId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExamineeExamApi - interface
 * @export
 * @interface ExamineeExamApi
 */
export interface ExamineeExamApiInterface {
    /**
     * Returns a minimal, read-only view of the individual exam for the examinee. Only the authenticated user matching the exam participant\'s email may access this endpoint. Shared reports are visible only when the exam is in STARTED status. 
     * @summary Get examinee read-only view of their individual exam
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamineeExamApiInterface
     */
    getExamineeExamView(certificationId: number, stageId: number, examId: string, options?: RawAxiosRequestConfig): AxiosPromise<ExamineeExamViewDto>;

}

/**
 * ExamineeExamApi - object-oriented interface
 * @export
 * @class ExamineeExamApi
 * @extends {BaseAPI}
 */
export class ExamineeExamApi extends BaseAPI implements ExamineeExamApiInterface {
    /**
     * Returns a minimal, read-only view of the individual exam for the examinee. Only the authenticated user matching the exam participant\'s email may access this endpoint. Shared reports are visible only when the exam is in STARTED status. 
     * @summary Get examinee read-only view of their individual exam
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamineeExamApi
     */
    public getExamineeExamView(certificationId: number, stageId: number, examId: string, options?: RawAxiosRequestConfig) {
        return ExamineeExamApiFp(this.configuration).getExamineeExamView(certificationId, stageId, examId, options).then((request) => request(this.axios, this.basePath));
    }
}

